export enum AnalyticsEventName
{
  FIRST_OPEN_AFTER_INSTALL = 'first_open_after_install',
  SESSION_START = 'session_start',
  SESSION_FINISH = 'session_finish',
  AD_VIEW   = 'ad_view',
  APPLOVIN_REVENUE_IMPRESSION = 'applovin_revenue_impression',
  APPLOVIN_REVENUE_USER_LEVEL = 'applovin_revenue_user_level',
  GAME_START = 'game_start',
  GAME_FINISH = 'game_finish',
  AD_CLICK = 'ad_click',
  AD_START = 'ad_start',
  AD_FINISH = 'ad_finish',
  AD_ERROR = 'ad_error',
  AD_APPLOVIN_REQUEST = 'ad_applovin_request',
  AD_APPLOVIN_ANSWER = 'ad_applovin_answer',
  AD_APPLOVIN_EXPIRED_RELOAD = 'ad_applovin_expired_reload',
  AD_APPLOVIN_LOADED_ECPM = 'ad_applovin_loaded_ecpm',
  AD_OPPORTUNITY = 'ad_opportunity',
  REWARDED_IMPRESSION = 'rewarded_impression',
  INTERSTITIAL_IMPRESSION = 'interstitial_impression',
  REWARD_COMPLETED_TOTAL = 'reward_completed_total',
  SESSION_MIN = 'session_min',
  REWARD_OFFER_CLICKED_TOTAL = 'reward_offer_clicked_total',
  BOOSTER_REWARD_OFFER_SHOWN = 'booster_reward_offer_shown',
  BOOSTER_REWARD_OFFER_CLICKED = 'booster_reward_offer_clicked',
  BOOSTER_REWARD_AD_RESULT = 'booster_reward_ad_result',
  BOOSTER_REWARD_GRANTED = 'booster_reward_granted',
  BOOSTER_REWARD_OFFER_CLOSED = 'booster_reward_offer_closed',
  // AD_BANNER_HIDE = 'ad_banner_hide',
}

export type AnalyticsEventNameLike = AnalyticsEventName | string;

export enum AnalyticsLevelResult
{
  EXIT = 'exit',
  WIN = 'win',
  LOSE = 'lose',
}

export enum AnalyticsPropertyKey
{
  USERID = 'userid',
  CUSTOMERUSERID = 'customeruserid',
  SIGNUPTIMESTAMP = 'signuptimestamp',
  PLATFORM = 'platform',
  COUNTRY = 'country',
  SOURCEID = 'sourceid',
  PLACEMENTID = 'placementid',
  ADNETWORK = 'adnetwork',
  USERLEVEL = 'userlevel',
  GAMETYPE = 'gametype',
  GAMENUMBER = 'gamenumber',
  RESULT = 'result',
  RESULTPOINTS = 'resultpoints',
  SESSIONID = 'sessionid',
  TIMESTAMP = 'timestamp',
  ADTYPE = 'adtype',
  ADCUSTOMID = 'adcustomid',
  REWARDCOMPLETEDTOTAL = "rewardcompletedtotal",
  GAMEID = "gameid",
  SESSIONMIN = "sessionmin",
  GAMETIME = "gametime",
  REWARDOFFERCLICKEDTOTAL = "rewardofferclickedtotal",
  DURATION = 'duration',
  AB_TEST = "abtest",
  AB_GROUP = "abgroup",
  CAMPAIGN = "campaign",
  PIC_ID = 'picid',
  ALBUM_ID = 'albumid',
  CELLS = 'cells',
  MOVES_DONE = 'movesdone',
  MONETIZATION_SEGMENT = 'monetization_segment',
  GAME_NUMBER = 'game_number',
  LEVEL_ID = 'level_id',
  DIFFICULTY = 'difficulty',
  DIFFICULTY_VALUE = 'difficulty_value',
  START_MOVES = 'start_moves',
  LEVEL_UID = 'level_uid',
  RESULT_POINTS = 'result_points',
  MOVES_DONE_V2 = 'moves_done',
  MOVES_PURCHASED_TIMES = 'moves_purchased_times',
  ELEMENTS_LEFT = 'elements_left',
  BOOSTERS_USED_FIREWORK = 'boosters_used_firework',
  BOOSTERS_USED_FIVE_BALLS = 'boosters_used_five_balls',
  BOOSTERS_USED_BIG_BALL = 'boosters_used_big_ball',
  BOOSTERS_USED_INFINITE_SHOTS = 'boosters_used_infinite_shots',
  ATTEMPT_NUMBER = 'attempt_number',
  MASS_ATTEMPT = 'mass_attempt',
  MASS_LEVEL = 'mass_level',
  MASS_APPLIED = 'mass_applied',
  MASS_SOURCE = 'mass_source',
}

export enum AnalyticsAdNetwork
{
  APPLOVIN = 'applovin',
  ADSGRAM = 'adsgram',
}

export enum AnalyticsGameType
{
  STRIPS = 'strips',
  RINGS = 'rings',
  TILES = 'tiles',
  CALENDAR = 'calendar',
  ROYAL_SMASH = 'royal_smash',
}

export enum AnalyticsAdType
{
  INTERSTITIAL = 'interstitial',
  REWARDED = 'rewarded',
  BANNER = 'banner',
}

export interface AnalyticsEventProperties
{
  [key: string]: unknown;
}

export interface AnalyticsContext
{
  app?: string;
  app_version?: string;
  is_prod?: boolean;
  platform?: string;
  device_id?: string;
  locale?: string;
  timezone_offset_minutes?: number;
  url?: string;
  user_agent?: string;
  screen?: { w: number; h: number; dpr: number };
}

export interface AnalyticsEvent
{
  name: AnalyticsEventNameLike;
  ts: number;
  seq: number;
  session_id: string;
  session_id_serv?: string;
  user_id?: string;
  context: AnalyticsContext;
  properties?: AnalyticsEventProperties;
}

export interface AnalyticsInitOptions
{
  enabled?: boolean;
  context?: Partial<AnalyticsContext>;
  session_id?: string;
  user_id?: string;
  common_properties?: AnalyticsEventProperties;
}
